module.exports = __webpack_public_path__ + "img/frxxvn-currency-guide-1.bbc394c5.jpg";